/** Shared layout styles for home and group post cards */

export const getPostListStyle = () => ({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: window.innerWidth <= 768 ? '10px 5px 80px 5px' : '20px 10px 100px 5px',
  boxSizing: 'border-box',
});

export const getPostCardStyle = () => ({
  borderRadius: window.innerWidth <= 768 ? '0' : '16px',
  padding: window.innerWidth <= 768 ? '20px 5px' : '18px 20px',
  marginBottom: 0,
  backgroundColor: '#ffffff',
  boxShadow:
    window.innerWidth <= 768
      ? 'none'
      : '0 1px 3px rgba(15, 23, 42, 0.04)',
  border: window.innerWidth <= 768 ? '1px solid #e8eef3' : '1px solid #e8eef3',
  borderLeft: window.innerWidth <= 768 ? 'none' : '1px solid #e8eef3',
  borderRight: window.innerWidth <= 768 ? 'none' : '1px solid #e8eef3',
  transition: 'all 0.3s ease',
  width: '100%',
  maxWidth: '100%',
  marginLeft: 0,
  marginRight: 0,
  boxSizing: 'border-box',
  overflow: 'hidden',
});

/**
 * Fluid type that scales with viewport width (auto-fits phone → desktop).
 * Prefer these over hardcoded mobile/desktop px jumps.
 */
export const postFonts = {
  author: 'clamp(0.9375rem, 0.85rem + 0.4vw, 0.9375rem)', // ~15px
  meta: 'clamp(0.75rem, 0.7rem + 0.25vw, 0.75rem)', // ~12px
  title: 'clamp(1.125rem, 1rem + 0.6vw, 1.25rem)', // ~18–20px
  body: 'clamp(0.9375rem, 0.875rem + 0.3vw, 0.9375rem)', // ~15px
  link: 'clamp(0.875rem, 0.8rem + 0.3vw, 0.875rem)', // ~14px
  action: 'clamp(0.875rem, 0.8rem + 0.35vw, 0.9375rem)', // ~14–15px
  reaction: 'clamp(0.8125rem, 0.75rem + 0.3vw, 0.875rem)', // ~13–14px
};

export const postAuthorStyle = {
  fontWeight: 600,
  fontSize: postFonts.author,
};

export const postMetaStyle = {
  fontSize: postFonts.meta,
  color: '#6b7280',
};

export const postTitleStyle = {
  fontSize: postFonts.title,
  fontWeight: '700',
  color: '#102a43',
  marginBottom: '16px',
  lineHeight: 1.3,
};

export const postTitleLinkStyle = {
  textDecoration: 'none',
  color: '#000758ff',
  fontSize: postFonts.title,
  fontWeight: '700',
  lineHeight: 1.3,
};

export const postContentStyle = {
  fontSize: postFonts.body,
  color: '#374151',
  marginBottom: '8px',
  whiteSpace: 'pre-wrap',
  lineHeight: 1.55,
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  maxWidth: '100%',
};

/** Fluid px helper for inline styles (no mobile inflation). */
export const fontSizePx = (desktopPx) =>
  `clamp(${Math.max(desktopPx - 1, 12)}px, ${desktopPx * 0.06}vw + ${desktopPx * 0.85}px, ${desktopPx}px)`;
